import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flex _ai-c" }
const _hoisted_2 = { class: "_flexcol _w-100 _gap-2" }
const _hoisted_3 = { class: "_w-100" }
const _hoisted_4 = { class: "_flexcol _gap-2 _mx-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_base_divider = _resolveComponent("base-divider")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, {
    content: "",
    class: "_flexcol"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_skeleton_image, {
          size: 42,
          class: "_ma-3"
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_skeleton_line, {
            height: 22,
            "width-percent": 30
          }),
          _createVNode(_component_skeleton_line, {
            height: 20,
            "width-percent": 20
          })
        ])
      ]),
      _createVNode(_component_base_divider, { class: "_my-0" }),
      _createElementVNode("div", {
        class: _normalizeClass($options.contentClasses)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass({ '_w-100': $options.isMobile })
        }, [
          _createVNode(_component_skeleton_image, {
            size: $options.mainImageSize,
            class: "_mx-3"
          }, null, 8 /* PROPS */, ["size"])
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_skeleton_line, {
              height: 22,
              "width-percent": 20
            }),
            _createVNode(_component_skeleton_line, {
              height: 28,
              "width-percent": 30
            }),
            _createVNode(_component_skeleton_line, {
              height: 22,
              "width-percent": 100
            }),
            _createVNode(_component_skeleton_line, {
              height: 22,
              "width-percent": 100
            }),
            _createVNode(_component_skeleton_line, {
              height: 20,
              "width-percent": 15
            })
          ])
        ])
      ], 2 /* CLASS */),
      _createVNode(_component_base_divider, { class: "_my-0" }),
      _createVNode(_component_skeleton_line, {
        class: "_ma-3",
        height: 20,
        "width-percent": 10
      })
    ]),
    _: 1 /* STABLE */
  }))
}